"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_INTERACTION_FOR_CHANGE = exports.ENRICHMENT = exports.ISSUE_BINDING_QUOTE = exports.SIGN_AGREEMENT = exports.GENERATE_DOCUMENT = exports.LOG = void 0;
var LOG = "log";
exports.LOG = LOG;
var GENERATE_DOCUMENT = "generateDocument";
exports.GENERATE_DOCUMENT = GENERATE_DOCUMENT;
var SIGN_AGREEMENT = "signAgreement";
exports.SIGN_AGREEMENT = SIGN_AGREEMENT;
var ISSUE_BINDING_QUOTE = "issueBindingQuote";
exports.ISSUE_BINDING_QUOTE = ISSUE_BINDING_QUOTE;
var ENRICHMENT = "enrichment";
exports.ENRICHMENT = ENRICHMENT;
var LOAD_INTERACTION_FOR_CHANGE = "loadInteractionForChange";
exports.LOAD_INTERACTION_FOR_CHANGE = LOAD_INTERACTION_FOR_CHANGE;
//# sourceMappingURL=CommandTypes.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-model/dist/journey/const/CommandTypes.js
// module id = 2073
// module chunks = 0